import styled from 'styled-components';

import {
  backgroundColor,
  borderRadius,
  color,
  margins,
  paddings,
  fontSize,
} from '../ui/utils';

const Button = styled.button`
  text-align: ${({ textAlign }) => textAlign || 'center'};
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'inherit')};
  border: 0;
  font-family: ${({ theme }) => theme.fontFamily.button};
  transition: all 0.2s;

  outline: none;
  cursor: pointer;

  ${({ width }) => `width: ${width};` || null};
  ${props => borderRadius(props.borderRadius)};
  ${props => backgroundColor(props.backgroundColor)};
  ${props => color(props.color)};
  ${props => margins(props)};
  ${props => paddings(props)};
  ${props => fontSize(props.fontSize)};

  &:hover {
    background-color: ${({ theme, hoverColor }) => theme.colors[hoverColor]};
    color: ${({ theme }) => theme.colors.blueDarker};
  }

  &:active {
    transform: scale(1.1);
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;

    ${props => backgroundColor(props.backgroundColor)};
    ${props => color(props.color)};
  }
`;

Button.defaultProps = {
  backgroundColor: 'grayLight',
  borderRadius: 'baseUp3',
  px: 'baseUp4',
  pb: 'baseDown2',
  pt: 'baseDown1',
  fontSize: 'baseUnit',
  hoverColor: 'green',
};

export default Button;
